import React from "react";

interface TextAreaInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  containerClassName?: string;
  errortext?: string;
  helpertext?: string;
}

export function TextAreaInput(props: TextAreaInputProps) {
  const {
    label,
    containerClassName,
    errortext,
    helpertext,
    className,
    ...textareaProps
  } = props;
  const extraClasses = className ? className : "";
  return (
    <div className={containerClassName}>
      {label && (
        <label
          htmlFor={props.id}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
        </label>
      )}
      <textarea
        {...textareaProps}
        className={`px-2 block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-gray-300 ring-1 ring-inset ${
          props.color === "error" ? "ring-error focus:ring-error" : ""
        } focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6 ${extraClasses}`}
      />
      <div className={`mt-1 ml-1 text-error text-sm`}>{errortext}</div>
      <div className={`mt-1 ml-1 text-gray-600 text-sm`}>{helpertext}</div>
    </div>
  );
}
